import { FC, useState } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import CustomBreadCrumbs from "../../custom-components/CustomBreadCrumbs";

interface PageTemplateProps {
    Page: FC;
    noBreadcrumbs?: boolean;
}

const PageTemplate: FC<PageTemplateProps> = (props) => {
    const [backgroundBlur, setBackgroundBlur] = useState(false);

    return (
        <>
            <Header backgroundBlur={backgroundBlur} setBackgroundBlur={setBackgroundBlur} />
            <div
                className={`relative flex flex-col tmin4:min-h-[calc(100vh-80px)] tmax4:min-h-[calc(100vh-72px)] ${
                    backgroundBlur ? "tmax5:blur" : undefined
                }`}
            >
                {!props.noBreadcrumbs && <CustomBreadCrumbs />}
                <props.Page />
                <Footer />
            </div>
        </>
    );
};

export default PageTemplate;
